// extracted by mini-css-extract-plugin
module.exports = {"section_courses":"uni_overview_courses_section_courses__b3786","title_wrapper":"uni_overview_courses_title_wrapper__28PJs","btn_wrapper":"uni_overview_courses_btn_wrapper__anOj0"};